import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Warning } from '@material-ui/icons'
import { compensationPopupColors } from '../styles'

const WarningMessage = ({ children }: React.PropsWithChildren<unknown>) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <Warning />
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default WarningMessage

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: 12,
    paddingLeft: 14,
    background: '#FEF7E0',
    border: `0.5px solid ${compensationPopupColors.orange}`,
    borderRadius: '8px',
  },
  icon: {
    marginRight: 14,
    color: compensationPopupColors.orange,
    display: 'flex',
  },
  content: {
    fontWeight: 700,
    fontSize: '13px',
    lineHeight: '130%',
    letterSpacing: '0.02em',
    color: '#212121',
    maxWidth: 440,
  },
})
